import React, { Fragment, useRef } from 'react';
import { PersonalizesSectionInfo } from './PersonalizedSectionInfo';
import { ContentContainer, ScrollContainer } from './Swipeable.elements';
import { defaultPosterViewportSwipeableConfig, defaultViewportSwipeableConfig } from './Swipeable.globals';
import { SwipeableButtons } from './SwipeableButtons';
import { SwipeableContainer } from './SwipeableContainer';
import { SwipeablePlaceholder } from './SwipeablePlaceholder';
import { isBrowser } from '../../../../play-core/utils/ssr-helper';
import { useVideoConfig } from '../../config/VideoAppContext';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Swipeable = ({
  children,
  placeholderAspectRatio,
  config = placeholderAspectRatio && placeholderAspectRatio < 1 ? defaultPosterViewportSwipeableConfig : defaultViewportSwipeableConfig,
  placeholder,
  buttonPositionFactor,
  isPersonalized = false,
  analyticsTitle
}) => {
  const {
    usePreview
  } = useVideoConfig();
  const swipeableRef = useRef(null);
  const scrollRef = useRef(null);
  const itemCount = React.Children.toArray(children).filter(child => !!child).length;
  const isEmpty = itemCount === 0 || !children;
  return /*#__PURE__*/_jsxs(SwipeableContainer, {
    children: [isEmpty && /*#__PURE__*/_jsx(SwipeablePlaceholder, {
      config: config,
      aspectRatio: placeholderAspectRatio,
      placeholder: placeholder
    }), !isEmpty && /*#__PURE__*/_jsxs(Fragment, {
      children: [isBrowser && /*#__PURE__*/_jsx(SwipeableButtons, {
        swipeableItemCount: itemCount,
        config: config,
        positionFactor: buttonPositionFactor,
        swipeableRef: swipeableRef,
        scrollRef: scrollRef,
        analyticsTitle: analyticsTitle
      }), /*#__PURE__*/_jsx(ContentContainer, {
        ref: swipeableRef,
        children: /*#__PURE__*/_jsx(ScrollContainer, {
          ref: scrollRef,
          config: config,
          children: children
        })
      })]
    }), isPersonalized && usePreview && /*#__PURE__*/_jsx(PersonalizesSectionInfo, {})]
  });
};